import { Moon, Sun } from "lucide-react";

import { Button, Tooltip } from "@/components/ui";
import { useTheme } from "@/lib/theme";

/** Light by default; the switch to dark is remembered on this device. */
export function ThemeToggle() {
  const { choice, setChoice } = useTheme();
  const Icon = choice === "dark" ? Moon : Sun;
  const label = choice === "dark" ? "Theme: dark" : "Theme: light";
  return (
    <Tooltip content={label}>
      <Button
        variant="ghost"
        size="icon"
        aria-label={label}
        onClick={() => setChoice(choice === "dark" ? "light" : "dark")}
      >
        <Icon />
      </Button>
    </Tooltip>
  );
}
